// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/valuations',
        component: () =>
            import(/* webpackChunkName: "investment.investment-valuations" */ '@/pages/[organisation]/investment/investment-valuations/investment-valuations.vue'),
        name: 'investment.investment-valuations.search-investment-valuations',
        meta: {
            loginRequired: true,
            permission: 'access.finance.investment.investment-valuations.view-investment-valuations',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import(/* webpackChunkName: "investment.investment-valuations" */ '@/pages/[organisation]/investment/investment-valuations/investment-valuation/new.vue'),
                name: 'investment.investment-valuations.create-investment-valuation',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.investment.investment-valuations.create-investment-valuation',
                },
            },
        ],
    },
];
